import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  guardAgbwFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";
import { getAgbwProgressOptions } from "@/openapi/@tanstack/react-query.gen";

const agbwSearchSchema = z.object({
  newVersion: z.boolean().optional().default(false),
});

export const Route = createFileRoute("/_protected/auditor/clients/$id/agbw")({
  validateSearch: agbwSearchSchema,
  beforeLoad: ({ context: { queryClient, active, ...context }, params }) => {
    const organizationId = context.user.organization?.id;
    if (!organizationId) {
      throw new Error("Organization ID is missing");
    }

    if (!guardAgbwFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }

    // Warm the query the layout suspends on; failures surface in that boundary
    // rather than as an unhandled rejection here.
    void queryClient
      .query(
        getAgbwProgressOptions({
          path: {
            org_id: organizationId,
            project_id: active.id,
          },
        }),
      )
      .catch(() => undefined);
  },
});
